import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const AXES = [
  { title: "Budget", text: "Tell us a per-gift range — we curate within it, no compromises on presentation." },
  { title: "Quantity", text: "From 25 executive hampers to 5,000 employee kits." },
  { title: "Occasion", text: "Diwali, onboarding, milestones, launches, appreciation weeks." },
  { title: "Recipient Profile", text: "Leadership, clients, teams, partners — each gets a different register." },
  { title: "Product Category", text: "Glassware, cutlery, appliances, cookware or mixed hampers." },
  { title: "Branding", text: "Logo sleeves, etched detail, message cards and custom inserts." },
  { title: "Packaging", text: "From gift-ready cartons to rigid presentation boxes." },
  { title: "Delivery", text: "Single address or multi-city dispatch, coordinated by one team." },
];

export default function CustomGifting() {
  useEffect(() => {
    document.title = "Custom Corporate Gifting — THE GOOD GRID";
  }, []);

  return (
    <div data-testid="custom-gifting-page" className="bg-charcoal text-ivory min-h-screen pt-28 lg:pt-36 pb-24">
      <div className="px-4 sm:px-8 lg:px-16">
        <Reveal><Eyebrow>Custom Corporate Gifting</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl mt-4 tracking-tight max-w-4xl leading-[1.05]">
            You bring the occasion.<br /><span className="italic text-champagne-light">We build the gift.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-ivory/50 mt-6 max-w-xl leading-relaxed">
            A bespoke service: tell us the budget, the people and the moment — our team assembles a gifting package around your brief.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <Link to="/request-quote" data-testid="custom-build-my-gift" className="group inline-flex items-center gap-2 mt-10 bg-champagne text-charcoal text-[11px] font-mono uppercase tracking-[0.22em] px-7 py-4 hover:bg-champagne-light transition-colors duration-300">
            Build My Gift <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10 mt-20">
          {AXES.map((a, i) => (
            <Reveal key={a.title} delay={(i % 4) * 0.08} className="border-r border-b border-white/10 p-8 hover:bg-[#161616] transition-colors duration-500">
              <p className="font-mono text-xs text-champagne tracking-[0.25em] mb-6">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-serif text-xl mb-2">{a.title}</h3>
              <p className="text-sm text-ivory/45 leading-relaxed">{a.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
